import React from 'react';
import { ApiButton, SectionHeader, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';


import { makeStyles } from 'tss-react/mui';
import { useGetDownloadTemplateUrl } from '../../../api-refactored/group-special-consideration/useGetDownloadTemplateUrl';
import { GroupScType } from '../../../models/SpecialConsideration';

const useStyles = makeStyles()((theme) =>
({
  downloadButton: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
   inputLabel: {
          marginBottom: theme.spacing(1),
          color: theme.color.text.textHeader,
        },
}));

interface DownloadTemplateProps {
  groupScType: GroupScType;
  amendment: boolean;
}

const DownloadTemplate = ({ groupScType, amendment }: DownloadTemplateProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { refetch: downloadTemplate, status: downloadTemplateStatus } = useGetDownloadTemplateUrl({
    groupScType,
    onSuccess: (res) => {
      const newWindow = window.open(res.url, '_blank', 'noopener,noreferrer');
      if (newWindow) {
        newWindow.opener = null;
      }
    },
  });

  return (
    <>
      <SectionHeader
        title={t('specialConsideration->>ApplyForSpecialConsideration.UploadRankingDetails')}
      />
      <Typography className={classes.inputLabel} variant="body1">
        {t('specialConsideration->>ApplyForSpecialConsideration.uploadInstruction')}
      </Typography>

      <Typography variant="body1">
        {t('specialConsideration->>UploadRankingDetail.DownloadTemplateInstruction')}
      </Typography>
      {groupScType === GroupScType.IND ? (
        <ul>
          <li>
            <Typography variant="body1">
              {t('specialConsideration->>UploadRankingDetail.DownloadTemplateIndividual1')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              {t('specialConsideration->>UploadRankingDetail.DownloadTemplateIndividual2')}
            </Typography>
          </li>
        </ul>
      ) : (
        <ul>
          <li>
            <Typography variant="body1">
              {t('specialConsideration->>UploadRankingDetail.DownloadTemplateGroup1')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              {t('specialConsideration->>UploadRankingDetail.DownloadTemplateGroup2')}
            </Typography>
          </li>
        </ul>
      )}
      <ApiButton
        id="button-download-template"
        className={classes.downloadButton}
        status={downloadTemplateStatus}
        variant="outlined"
        size="medium"
        onClick={() => downloadTemplate()}
        disabled={amendment}
      >
        <IconWithLabel
          iconName={IconName.download}
          iconSize="M"
          label={t('specialConsideration->>UploadRankingDetail.DownloadExcelTemplate')}
          typographyProps={{
            variant: 'h5',
            color: 'inherit',
          }}
        />
      </ApiButton>
    </>
  );
};

export default DownloadTemplate;
